export default __webpack_public_path__ + "static/media/Legguards of the Vanguard.df353a24.jpg";